module.exports = "<svg viewBox=\"25 25 50 50\">\r\n  <circle cx=\"50\" cy=\"50\" r=\"20\"></circle>\r\n</svg>"